import { render, staticRenderFns } from "./OrderWarehouse.vue?vue&type=template&id=00bdfb9e"
import script from "./OrderWarehouse.vue?vue&type=script&lang=js"
export * from "./OrderWarehouse.vue?vue&type=script&lang=js"
import style0 from "./OrderWarehouse.vue?vue&type=style&index=0&id=00bdfb9e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports